export default __webpack_public_path__ + "static/media/Fullscreen.a33b5d3c.svg";